import { CommonModule } from '@angular/common';
import {
  Component, EventEmitter, forwardRef, Input, NgModule, Output
} from '@angular/core';
import {
  ControlValueAccessor, NG_VALUE_ACCESSOR
} from '@angular/forms';

enum enLabelPosition {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom'
};

@Component({
  selector: 'switchery-ios',
  templateUrl: './switchery-ios-adapter.component.html',
  styleUrls: ['./switchery-ios-adapter.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SwitcheryIosAdapterComponent),
    multi: true
  }],
})
export class SwitcheryIosAdapterComponent {

/** Compat inputs “classiques” de switchery */
  @Input() disabled = false;
  @Input() readonly = false;
  /** Libellés ON/OFF (optionnels) */
  @Input() label: string  = '';   // true = icône
  @Input() helpText: string  = '';   // true = icône
  @Input() onLabel: string  = '';   // true = icône
  @Input() offLabel: string  = ''; // false = icône
  /** Taille Kendo: 'small' | 'medium' | 'large' */
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  /** Accessibilité / focus */
  @Input() tabindex = 0;

  /** Événement “change” à la switchery */
  @Output() change = new EventEmitter<boolean>();
  @Input() labelPosition: enLabelPosition = enLabelPosition.Left;

  value = false;

  // CVA
  private onChangeFn: (v: boolean) => void = () => {};
  private onTouchedFn: () => void = () => {};

  writeValue(v: boolean): void { this.value = !!v; }
  registerOnChange(fn: any): void { this.onChangeFn = fn; }
  registerOnTouched(fn: any): void { this.onTouchedFn = fn; }
  setDisabledState(isDisabled: boolean): void { this.disabled = isDisabled; }

  onValueChange(v: boolean) {
    this.value = v;
    this.onChangeFn(v);
    this.change.emit(v); // pour compat avec (change) de l’ancienne lib
  }

  get labelWrapperClass(): string {
    switch (this.labelPosition) {
      case enLabelPosition.Left: return 'd-flex align-items-center';
      case enLabelPosition.Right: return 'd-flex align-items-center flex-row-reverse';
      case enLabelPosition.Top: return 'd-flex flex-column align-items-start';
      case enLabelPosition.Bottom: return 'd-flex flex-column align-items-end flex-column-reverse';
      default: return 'd-flex align-items-center';
    }
  }
}

